import {useQuery} from '@tanstack/react-query';
import {GetCityLocationParams} from 'domain/usecases/private/booking-flow/health/get-city-location';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getCityLocation} from '../../services/getCityLocation';

function useGetCityLocationQuery(params: GetCityLocationParams) {
	return useQuery({
		queryKey: [QUERY_KEYS.CITY_LOCATION_GUIDE, params],
		queryFn: ({signal}) => getCityLocation({signal, ...params}),
		enabled: Boolean(params.latitude && params.longitude),
	});
}

export {useGetCityLocationQuery};
